module.exports = __webpack_public_path__ + "img/lifestyle.77fb89e6.jpg";